import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.figure`
  margin-top: calc(var(--fr) * 2);
  margin-bottom: calc(var(--fr) * 2.5);

  img {
    display: block;
  }

  video,
  audio {
    width: 100%;
  }
`;

const Description = styled.figcaption`
  text-align: center;
  margin-top: calc(var(--fr) * 0.5);
  font-size: var(--fs-base);
`;

const ArticleAsset = ({ url, description, contentType }) => {
  let element;

  if (contentType.includes('video')) {
    element = (
      <video controls controlsList="nodownload noplaybackrate">
        <source src={url} type={contentType} />
      </video>
    );
  }

  if (contentType.includes('audio')) {
    element = (
      <audio controls controlsList="nodownload noplaybackrate">
        <source src={url} type={contentType} />
      </audio>
    );
  }

  if (contentType.includes('image')) {
    element = <img src={url} alt="" />;
  }

  if (!element) {
    return null;
  }

  return (
    <Wrapper>
      {element}
      {description && <Description>{description}</Description>}
    </Wrapper>
  );
};

ArticleAsset.propTypes = {
  url: PropTypes.string.isRequired,
  description: PropTypes.string,
  contentType: PropTypes.string.isRequired,
};

export default ArticleAsset;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/ArticleAsset.js